type Progress = {
    total: number;
    loaded: number;
    index: number;
};

export class Base64FileReader {
    private aborted = false;

    public read(blob: Blob): Promise<string> {
        this.aborted = false;
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                resolve(Base64FileReader.getResult(reader));
            };
            reader.onerror = () => {
                reject(reader.error);
            };

            reader.readAsDataURL(blob);
        });
    }

    public async *readByChunk(blob: Blob, chunkSize: number): AsyncIterable<[string, Progress]> {
        let loaded = 0;
        let index = 0;
        while (loaded < blob.size && !this.aborted) {
            const chunk = blob.slice(loaded, loaded + chunkSize);
            loaded += chunk.size;
            yield [await this.read(chunk), { total: blob.size, loaded, index: index++ }];
        }
    }

    public abort(): void {
        this.aborted = true;
    }

    protected static getResult({ result }: { result: any }): string {
        if (_.isString(result)) {
            const index = result.indexOf('base64,');
            if (index !== -1) {
                return result.substr(index + 7);
            }
        }
        return result;
    }
}
